import React from 'react';
import { getLightBackgroundColor } from '../../moduleServices/colorUtils';

const NoteCard = ({ note, onClick, viewMode = 'preview' }) => {
  const formatDate = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric'
    });
  };

  const getPreview = (content) => {
    if (!content) return 'No content';
    const plainText = content.replace(/<[^>]*>/g, '').trim();
    return plainText.length > 150 ? plainText.substring(0, 150) + '...' : plainText;
  };

  const hasTitle = (note.title || '').trim().length > 0;
  const titleDisplay = hasTitle
    ? note.title
    : <span className="text-gray-400 italic">no title</span>;

  const clusterColor = note.cluster?.color;
  const lightBackgroundColor = getLightBackgroundColor(clusterColor);

  return (
    <div
      onClick={onClick}
      className={`rounded-xl shadow p-3 cursor-pointer hover:shadow-md transition-shadow relative select-none ${viewMode === 'title-only' ? 'min-h-[60px] flex flex-col justify-center' : ''} ${clusterColor ? 'border-l-4' : ''}`}
      style={{
        ...(clusterColor ? { borderLeftColor: clusterColor } : {}),
        ...(lightBackgroundColor ? { backgroundColor: lightBackgroundColor } : { backgroundColor: 'white' })
      }}
    >
      {viewMode === 'title-only' ? (
        <>
          {/* Title Only Mode - Centered layout */}
          <div className="flex items-center justify-between gap-2 min-w-0">
            <h3 className="text-lg font-semibold text-gray-800 line-clamp-1 flex-1 min-w-0">
              {titleDisplay}
            </h3>
            <span className="text-xs text-gray-400 whitespace-nowrap flex-shrink-0">
              {formatDate(note.updated_at)}
            </span>
          </div>
        </>
      ) : (
        <>
          {/* Preview Mode - Original layout */}
          <span className="absolute top-2 right-2 text-xs text-gray-400">
            {formatDate(note.updated_at)}
          </span>
          <h3 className="text-lg font-semibold text-gray-800 mb-1 pr-16 line-clamp-1">
            {titleDisplay}
          </h3>
          <p className="text-sm text-gray-600 line-clamp-3 whitespace-pre-wrap">
            {getPreview(note.content)}
          </p>
        </>
      )}
    </div>
  );
};

export default NoteCard;
